import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TrendIncidentResponse} from '@npck/af-frontend-api';
import {LocalizationService, Spinner} from '@npck/libs/commons';
import {TrendIncidentForm} from '../trend-incident/trend-incident.component';

@Component({
    selector: 'af-trend-incident-expansion-panel',
    templateUrl: './trend-incident-expansion-panel.component.html',
    styleUrl: './trend-incident-expansion-panel.component.scss',
    standalone: false
})
export class TrendIncidentExpansionPanelComponent {
    @Input() trendIncident: TrendIncidentResponse;
    @Input() trendIncidentForm: FormGroup<TrendIncidentForm>;
    @Input() showDeleteButton: boolean;
    @Input() index: number;
    @Input() viewIndex: number | string;
    @Output() deleteTrendIncidentListener = new EventEmitter<number>();
    Spinner = Spinner;
    private _expanded = false;
    private wasExpanded = false;

    constructor(
        private localizationService: LocalizationService,
    ) {
    }

    get expanded(): boolean {
        return this._expanded;
    }

    @Input()
    set expanded(value: boolean) {
        if (value) {
            this._expanded = true;
            this.wasExpanded = true;
        } else {
            if (!this.wasExpanded) {
                this._expanded = false;
            }
        }
    }

    getTrendIncidentTitle = (): string => {
        return this.localizationService.getLocalizedKey('i18n_af_labelTrendIncidentTitle', {
            index: this.trendIncident?.incidentId ?? `№${this.viewIndex}`,
        });
    };
}
